export const hasAdminPermissions = (userRole?: string) => {
  return userRole === 'OWNER' || userRole === 'ADMIN';
};

export const hasOwnerPermissions = (userRole?: string) => {
  return userRole === 'OWNER';
};

export const isCurrentUser = (userId: string, currentUserId?: string) => {
  return userId === currentUserId;
};
